export { IntlProvider } from './intl-provider'
export { Translate, useTranslate, translate } from './translate'
export {
	getLocale,
	getFormattingLocale,
	getMessages,
	getFnsLocale,
	resolveLocale,
	setLocale,
	SUPPORTED_LOCALES,
} from './actual-locale'
export type { AppLocale } from './actual-locale'
